import { Dropdown, Modal, PrimaryButton } from "@fluentui/react";
import React, { useEffect, useState, useContext } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import { assignEvaluator, assignRadForPeerReview, getEvaluatorForEvaluation, getPacsNodeForSending, getRadiologistForPeerReview, pullPacsStudyReport, sendToNodes } from "../../../../../service/StudyListService";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import toastContext from "../../../../../context/toast/ToastContext";
import { TAB_NAME, TOAST_TYPE } from "../../../../../constants/Constants";
import SearchableDropDown from "../../../../ReportTemplates/helper/SearchDropdown";
import OutsideClickHandler from 'react-outside-click-handler';

const EvaluatorAssignment = (props) => {
  const [loading, setLoading] = useState(false);
  const { ref, setLoaderRunning, showModal, setShowModal } = useContext(loaderContext);
  const [evaluatorList, setEvaluatorList] = useState([]);
  const [selectedEvaluatorId, setSelectedEvaluatorId] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [t] = useTranslation();
  const { showToastv2 } = useContext(toastContext);
  const [evaluatorFilteredItems, setEvaluatorFilteredItems] = useState(evaluatorList);

  const {setRefreshRequired,
    refreshRequired,
    dataQueryState,
    setDataQueryState,
} = useContext(studylistContext);
  
  
  let PrimaryButtonList = [
    {
      title: t("button.close"),
      onclick: () => props.setShowEvaluatorAssignmentModal(false),
    },
  ];

  console.log(props);

  const getPeerEvaluator = async() =>{
    setLoading(true);
    const response = await getEvaluatorForEvaluation(props.studyId, props.clientId, props.firmId);
    console.log("Getting evaluator for peer review :", response)
    if (response.status == 200 && response.data.result == "SUCCESS") {
      if(response.data.data != null && response.data.data != undefined && response.data.data.evaluators.length > 0){
        let evaluatorListItem = [];
        response.data.data.evaluators.filter((evaluator) => evaluator.id != props.evaluatorId).map((evaluator) => {
          evaluatorListItem.push({
            key: evaluator.id,
            text: evaluator.firstName + " " + evaluator.lastName,
          });
        });
        setEvaluatorList(evaluatorListItem);
        setEvaluatorFilteredItems(evaluatorListItem);
        if(response.data.data.reviewerId){
          let rad = evaluatorListItem.filter((rad)=>rad.key == response.data.data.reviewerId)
          setSelectedEvaluatorId(rad[0].key);
        }
      }else{
        setResponseMessage("No Evaluator available!");
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
    
  }

  const handleDropdownChange = (event, item) => {
    console.log(item);
    if (item) {
      setSelectedEvaluatorId(item.key);
    }
    setEvaluatorFilteredItems(evaluatorList)
  };

  const handlePeerReviewAssignment = async() =>{
    console.log("assigning to peer reviewer ", selectedEvaluatorId);
    if(selectedEvaluatorId.length == 0){
      showToastv2(TOAST_TYPE.INFO, "Select an evaluator!");
      return;
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await assignEvaluator(props.studyId, selectedEvaluatorId);
    console.log("Send to evaluator response :", response)
    if (response.data.result === "SUCCESS") {
      showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
      props.setShowEvaluatorAssignmentModal(false);
      setTimeout(() => {
        setRefreshRequired(() => {
          const newItem = { ...refreshRequired };
          newItem[TAB_NAME.REVIEWCOMPLETE].alreadyLoaded = false;
          console.log(newItem);
          return newItem;
        });
      }, 10);

      let newData = dataQueryState?.data?.rows.filter(
        (row) => row.id !== props.studyId
      );
      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState,
        };
        newValue.data.rows = newData;
        return newValue;
      });
    } else {
      showToastv2(TOAST_TYPE.ERROR, response.data.message ? response.data.message : "Some error occurred in assiging to evaluator");
    }
    setLoaderRunning(false);
    ref.current.complete();
  }

  useEffect(() => {
    getPeerEvaluator();
  }, []);

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={`${t("study-list.actions.evaluator-assignment")}`}
        handleCancel={() => props.setShowEvaluatorAssignmentModal(false)}
      />
    ),
    body: (
      <EvaluatorAssignmentModal
        evaluatorList={evaluatorList}
        responseMessage={responseMessage}
        loading={loading}
        setShowEvaluatorAssignmentModal={props.setShowEvaluatorAssignmentModal}
        handleDropdownChange={handleDropdownChange}
        selectedEvaluatorId={selectedEvaluatorId}
        setSelectedEvaluatorId={setSelectedEvaluatorId}
        handlePeerReviewAssignment={handlePeerReviewAssignment}
        evaluatorFilteredItems={evaluatorFilteredItems}
        setEvaluatorFilteredItems={setEvaluatorFilteredItems}
      />
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={PrimaryButtonList}
      />
    ),
    width: "400px",
  };

  return (
    <>
      <ModalMain
        updatedModal = {true}
        modalDetails={modalDetails}
        showModal={props.showEvaluatorAssignmentModal}
      />
    </>
  );
};

export default EvaluatorAssignment;

export const EvaluatorAssignmentModal = (props) => {
  const [t] = useTranslation();
  const { getThemeColor } = useContext(themeContext);

  const dropDownStyle = {
    dropdown: {
      width: "100%"
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "300px",
      overflowY: 'auto',
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white"
    },
  };

  const noReason = {
    padding: "10px",
    textAlign: "center",
    color: getThemeColor("primary-color"),
  };

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const sendNodeStyle = {
    height: "34px",
    margin: "0",
    marginBottom: "25px",
    display:"flex",
    width:"100%",
    alignItems: "center",
    justifyContent: "space-between",
  };

  console.log("evaluator list :", props.evaluatorList)
  // let evaluatorList = [];
  // props.evaluatorList.map((modality) => {
  //   evaluatorList.push({
  //     key: modality.id,
  //     text: modality.name,
  //   });
  // });


  const handleClickOutside = () => {
    props.setEvaluatorFilteredItems(props.evaluatorList)
  };

  const onDropDownSearch = (
    searchValue,
    initialValues
  ) => {
    if (searchValue == null || searchValue == "") {
      return [...initialValues];
    }
    const filteredOptions = [...initialValues].filter(
      (i) => {
        let text = i.text.toLowerCase();
        return text.includes(searchValue.toLowerCase());
      }
    );


    return filteredOptions;
  }

  
  return (
    <>
      {props.loading ? (
        <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      ) : (
        <div className="upload-study-modal-container">
          <div className="container-content">
            {props.evaluatorList.length !== 0 ? (
              <>
                <div style={sendNodeStyle}>
                  <div className="ms-sm12 ms-md8 ms-lg6 ms-xl6" style={{flexGrow:"2"}}>
                    <OutsideClickHandler onOutsideClick={handleClickOutside}>
                      <SearchableDropDown
                        dropDownStyle={dropDownStyle}
                        selectedKey={props.selectedEvaluatorId}
                        onChange={props.handleDropdownChange}
                        onSearchValueChanged={(searchValue) => {
                          console.log("search value ", searchValue);
                          const newOptions = onDropDownSearch(
                            searchValue,
                            props.evaluatorList
                          );
                          props.setEvaluatorFilteredItems(newOptions);
                        }}
                        options={
                          props.evaluatorFilteredItems.length > 0
                            ? props.evaluatorFilteredItems
                            : []
                        }
                        name="pacs node list"
                        className="form-field ms-Grid-col custom-pacs-node-dropdown modal-scroll"
                        style={{ width: "100%" }}
                        label=""
                        placeholder="Select Evaluator"
                       // isMultiSelect={true}
                        isRequired={false}
                      />
                    </OutsideClickHandler>
                  </div>
                  <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" style={{flexGrow:"1"}}>
                    <PrimaryButton onClick={props.handlePeerReviewAssignment}>
                      Assign
                    </PrimaryButton>
                  </div>
                </div>
              </>
            ) : (
              <p style={noReason}>{props.responseMessage || "No evaluator available"}</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};
